<template>
  <div
    class="app"
  >
    <ScLoader :show="isLoading" />
    <ScGlobalBanner
      :banner-type="translations.globalBanner.bannerType"
      :banner-message-markup="translations.globalBanner.bannerMessage"
      :banner-enabled="translations.globalBanner.bannerEnabled"
    />
    <Teleport to="body">
      <chat-client-web
        v-if="shouldRenderChatClient"
        :config.prop="chatClientConfig"
        @chat-client-is-active="onChatClientIsActive"
      />
    </Teleport>
    <router-view v-slot="{ Component }">
      <transition
        name="fade-view"
        mode="out-in"
        @after-leave="afterLeave"
      >
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>
<script>
import ScGlobalBanner from '@garmin/support-components/src/components/ScGlobalBanner/index.vue';
import ScLoader from '@garmin/support-components/src/components/ScLoader/index.vue';
import { fireUtagView } from '@garmin/support-analytics';
import { mapState } from 'pinia';
import { useGlobalStore } from './stores/global/index.js';
import TranslationsMixin from './mixins/translations';
import useChatClientWeb from './composables/useChatClientWeb.js';

export default {
  name: 'App',
  components: {
    ScGlobalBanner,
    ScLoader,
  },
  mixins: [TranslationsMixin],
  setup() {
    return useChatClientWeb();
  },
  computed: {
    ...mapState(useGlobalStore, ['isLoading']),
  },
  watch: {
    $route() {
      fireUtagView();
    },
  },
  methods: {
    afterLeave() {
      this.$root.$emit('triggerScroll');
    },
  },
};
</script>
<style lang="scss" src="./styles/app/index.scss"></style>
